import styled from "styled-components";

export const UserStatusPersonalManagerStyled = styled.div`
    padding: 16px;
    border-radius: 16px;
    background: var(--color-background-secondary);
    box-shadow: var(--shadow-primary);
    flex: 1;
`;

export const UserStatusPersonalManagerAvatarStyled = styled.div`
    border-radius: 50%;
    height: 40px;
    width: 40px;
    overflow: hidden;
    
    img {
        height: 100%;
        width: 100%;
    }
`;

export const UserStatusPersonalManagerAvatarDefaultStyled = styled.div`
    background: var(--color-fill-secondary);
    border-radius: 50%;
    color: var(--color-label-secondary);
    overflow: hidden;
`;
